import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface BrokerSwitcherPillProps {
  brokerName: string | null;
}

const BROKER_FAMILY: Record<string, { label: string; family: string }> = {
  zerodha:    { label: 'Zerodha',    family: 'IN Equity' },
  groww:      { label: 'Groww',      family: 'IN Equity' },
  dhan:       { label: 'Dhan',       family: 'IN Equity' },
  upstox:     { label: 'Upstox',     family: 'IN Equity' },
  angelone:   { label: 'Angel One',  family: 'IN Equity' },
  'angel one':{ label: 'Angel One',  family: 'IN Equity' },
  oanda:      { label: 'OANDA',      family: 'Forex' },
  metatrader: { label: 'MetaTrader', family: 'Forex' },
  xm:         { label: 'XM',         family: 'Forex' },
  alpaca:     { label: 'Alpaca',     family: 'US Stocks' },
  'interactive brokers': { label: 'IBKR', family: 'US Stocks' },
  binance:    { label: 'Binance',    family: 'Crypto' },
  coinbase:   { label: 'Coinbase',   family: 'Crypto' },
  kraken:     { label: 'Kraken',     family: 'Crypto' },
  bybit:      { label: 'Bybit',      family: 'Crypto' },
  kucoin:     { label: 'KuCoin',     family: 'Crypto' },
};

function resolveBroker(name: string): { label: string; family: string } {
  const key = name.toLowerCase();
  if (BROKER_FAMILY[key]) return BROKER_FAMILY[key];
  for (const [k, v] of Object.entries(BROKER_FAMILY)) {
    if (key.includes(k)) return v;
  }
  return { label: name, family: 'Custom' };
}

export default function BrokerSwitcherPill({ brokerName }: BrokerSwitcherPillProps) {
  const navigate = useNavigate();

  if (!brokerName) {
    return (
      <button
        onClick={() => navigate('/brokers')}
        className="flex items-center gap-1.5 px-2 py-1 rounded border border-[hsl(var(--card-border))] hover:border-accent-amber/60 hover:bg-accent-amber/5 transition-colors group"
        title="No broker connected — click to connect"
      >
        <div className="w-1.5 h-1.5 rounded-full bg-muted-foreground/60" />
        <span className="text-[10px] text-muted-foreground font-medium tracking-wide">
          NO BROKER · CONNECT
        </span>
        <ChevronRight className="w-3 h-3 text-muted-foreground group-hover:text-accent-amber transition-colors" />
      </button>
    );
  }

  const { label, family } = resolveBroker(brokerName);

  return (
    <button
      onClick={() => navigate('/brokers')}
      className="flex items-center gap-1.5 px-2 py-1 rounded border border-[hsl(var(--card-border))] hover:border-[hsl(var(--bull)/0.6)] hover:bg-[hsl(var(--bull)/0.05)] transition-colors group"
      title={`Trading via ${label} — click to switch broker`}
    >
      <div className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--bull))]" />
      <span className="text-[10px] text-muted-foreground font-medium tracking-wide">
        VIA <span className="text-foreground">{label}</span>
        <span className="text-muted-foreground/70"> · {family}</span>
      </span>
      <ChevronRight className="w-3 h-3 text-muted-foreground group-hover:text-[hsl(var(--bull))] transition-colors" />
    </button>
  );
}
